import { faXmark, faTrash, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Point } from "peaks.js";
import * as React from "react";
import { ToastContentProps } from "react-toastify";

export interface WarningToastProps extends ToastContentProps<any> {
    eventTimeText: string;
    point: Point;
}

export function WarningToast({
    closeToast,
    data,
    eventTimeText,
    point
}: WarningToastProps) {
    const handleRemove = () => {
        data.onUndo();
        closeToast();
    };

    const handleJumpTo = () => {
        data.onJumpTo(point.time);
    }

    return (
        <div className="row" style={{ width: "100%" }}>
            <div className="col-xs-12">
                <span>{eventTimeText} within threshold of other events.</span>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <div className="pull-right">
                        <button onClick={handleJumpTo} className="btn btn-primary ">
                            <FontAwesomeIcon icon={faShare} />
                        </button>&nbsp;
                        <button onClick={handleRemove} className="btn btn-danger">
                            <FontAwesomeIcon icon={faTrash} />
                        </button>&nbsp;
                        <button onClick={closeToast} className="btn btn-primary btn-outline">
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
